const View = require("presto-ui").baseView;

class MobileHome extends View {

	constructor(props, children, state) {
		super(props, children, state);
		this.shouldCacheScreen = false;
	}

}

module.exports = MobileHome;



// WEBPACK FOOTER //
// ./controller/pages/Mobile/MobileHome.js